import { inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { Command, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface ProductActivateParams {
    readonly id: number;
    readonly action: 'activate' | 'deactivate'
}

export type ProductActivateResponse = {
    object: {
        id: number,
        version: string
    }
};

export class ProductActivateCommand extends Command<ProductActivateParams, ProductActivateResponse> { }

@CommandHandlerFor(ProductActivateCommand)
@Injectable({ providedIn: 'root'})
export class ProductActivateCommandHandler {
    #activateUrl = TaggedUrl.join('products/:id/activate', [Tags.Api]);
    #deactivateUrl = TaggedUrl.join('products/:id/deactivate', [Tags.Api]);
    #http = inject(Http) as HttpService;

    async handleAsync(cmd: ProductActivateCommand): Promise<ProductActivateResponse> {
        const url = cmd.params?.action === 'activate'
            ? this.#activateUrl
            : this.#deactivateUrl;
        const { data } = await this.#http.put(fillPlaceholders(url, { id: cmd.params?.id }));
        return data;
    }
}
